import { EntityDiagramActionFn, NodeMouseLeaveAction } from '../types';

export const nodeMouseLeaveAction: EntityDiagramActionFn<
  NodeMouseLeaveAction
> = (state, _action, _queueEffect) => {
  return { ...state, highlightedIds: new Set() };
};
